(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-explorer"] && !Shopify.designMode) return;
  try {
    
(function(){
function nvRun(){
document.querySelectorAll('[data-fx]').forEach(function(panel){
  var root=panel.closest('.nv-fx'),intro=panel.querySelector('[data-fx-intro]'),nav=panel.querySelector('[data-fx-nav]');
  var openBtn=panel.querySelector('[data-fx-open]'),closeBtn=panel.querySelector('[data-fx-close]');
  var items=[].slice.call(panel.querySelectorAll('.nv-fx__item')),pills=[].slice.call(panel.querySelectorAll('[data-fx-item]'));
  var shots={};panel.querySelectorAll('[data-fx-shot]').forEach(function(s){shots[s.dataset.fxShot]=s;});
  var up=panel.querySelector('[data-fx-step="-1"]'),down=panel.querySelector('[data-fx-step="1"]');
  var current=-1,shown='overview';
  function showShot(key){
    if(key===shown)return;
    var prev=shots[shown],next=shots[key];
    if(prev){prev.classList.remove('is-active');prev.classList.add('is-leaving');setTimeout(function(){prev.classList.remove('is-leaving');},600);}
    if(next)next.classList.add('is-active');
    shown=key;
  }
  function select(i,focus){
    if(i<0||i>=items.length)return;
    items.forEach(function(it,k){it.classList.toggle('is-active',k===i);pills[k].setAttribute('aria-expanded',k===i?'true':'false');});
    current=i;showShot(String(i));
    up.disabled=i===0;down.disabled=i===items.length-1;
    if(focus)pills[i].focus({preventScroll:true});
  }
  function open(){
    root.classList.add('is-open');nav.hidden=false;openBtn.setAttribute('aria-expanded','true');closeBtn.tabIndex=0;
    items.forEach(function(it){it.style.animation='none';void it.offsetWidth;it.style.animation='';});
    select(0);
    var active=items[0].querySelector('.nv-fx__card');if(active)active.setAttribute('tabindex','-1');
    closeBtn.focus({preventScroll:true});
  }
  function close(){
    root.classList.remove('is-open');nav.hidden=true;openBtn.setAttribute('aria-expanded','false');closeBtn.tabIndex=-1;
    items.forEach(function(it){it.classList.remove('is-active');});current=-1;showShot('overview');
    openBtn.focus({preventScroll:true});
  }
  openBtn.addEventListener('click',open);
  closeBtn.addEventListener('click',close);
  pills.forEach(function(p,i){p.addEventListener('click',function(){select(i);});});
  up.addEventListener('click',function(){select(current-1,true);});
  down.addEventListener('click',function(){select(current+1,true);});
  panel.addEventListener('keydown',function(e){
    if(!root.classList.contains('is-open'))return;
    if(e.key==='ArrowDown'||e.key==='ArrowRight'){e.preventDefault();select(Math.min(items.length-1,current+1),true);}
    else if(e.key==='ArrowUp'||e.key==='ArrowLeft'){e.preventDefault();select(Math.max(0,current-1),true);}
    else if(e.key==='Home'){e.preventDefault();select(0,true);}
    else if(e.key==='End'){e.preventDefault();select(items.length-1,true);}
    else if(e.key==='Escape'){close();}
  });
});
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
function nvRun(){
var header=document.querySelector('[data-header]'),dock=document.querySelector('[data-dock]');
function onScroll(){
  var y=window.scrollY,h=window.innerHeight;
  header.classList.toggle('is-scrolled',y>h*0.55);
  if(dock){
    var foot=document.querySelector('.nv-footer'),nearFoot=foot&&foot.getBoundingClientRect().top<h;
    dock.classList.toggle('is-on',y>h*0.9&&!nearFoot);
  }
}
window.addEventListener('scroll',onScroll,{passive:true});onScroll();
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
function nvRun(){
var hero=document.querySelector('[data-hero]');
if(hero){
  var canvas=hero.querySelector('[data-hero-canvas]'),ctx=canvas.getContext('2d');
  var inner=hero.querySelector('[data-hero-inner]'),mark=hero.querySelector('[data-hero-mark]');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var W=0,H=0,dpr=1,t0=performance.now(),running=false,raf=0;
  var LINES=44,STEP=10;
  var m={x:0,y:0,tx:0,ty:0,active:false};

  function resize(){
    dpr=Math.min(2,window.devicePixelRatio||1);
    W=canvas.clientWidth;H=canvas.clientHeight;
    canvas.width=Math.round(W*dpr);canvas.height=Math.round(H*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
    if(!m.active){m.x=m.tx=W*.68;m.y=m.ty=H*.8;}
    if(!running)draw(reduce?4:0);
  }
  function ease(x){x=Math.max(0,Math.min(1,x));return 1-Math.pow(1-x,3);}

  function draw(t){
    ctx.clearRect(0,0,W,H);
    if(!m.active){m.tx=W*(.55+.25*Math.sin(t*.13));m.ty=H*(.78+.06*Math.sin(t*.21));}
    m.x+=(m.tx-m.x)*.06;m.y+=(m.ty-m.y)*.06;
    var grad=ctx.createRadialGradient(m.x,m.y,0,m.x,m.y,Math.max(260,W*.22));
    grad.addColorStop(0,'rgba(135,216,247,1)');
    grad.addColorStop(.55,'rgba(135,216,247,.55)');
    grad.addColorStop(1,'rgba(150,158,166,.32)');
    ctx.strokeStyle=grad;
    var horizon=H*.5;
    for(var i=0;i<LINES;i++){
      var k=i/(LINES-1),p=Math.pow(k,1.85);
      var y0=horizon+(H-horizon+30)*p;
      var amp=1.5+20*p,reveal=W*ease((t-.15-(1-k)*.5)/1.5);
      if(reveal<=0)continue;
      ctx.globalAlpha=(.1+.8*p);
      ctx.lineWidth=.5+1.1*p;
      ctx.beginPath();
      for(var x=0;x<=reveal+STEP;x+=STEP){
        var n=Math.sin(x*(.0026+.004*(1-p))+t*.55+i*.37)*.55+Math.sin(x*.0105-t*.8+i*.9)*.25+Math.sin(x*.0012+t*.21+i*.11)*.45;
        var dx=x-m.x,dy=y0-m.y,g=Math.exp(-(dx*dx)/(2*150*150)-(dy*dy)/(2*110*110));
        var y=y0+n*amp-g*(10+26*p);
        if(x===0)ctx.moveTo(x,y);else ctx.lineTo(x,y);
      }
      ctx.stroke();
    }
    ctx.globalAlpha=1;
  }
  function loop(now){
    draw((now-t0)/1000);
    raf=requestAnimationFrame(loop);
  }
  function start(){if(running||reduce)return;running=true;raf=requestAnimationFrame(loop);}
  function stop(){running=false;cancelAnimationFrame(raf);}

  resize();
  window.addEventListener('resize',resize);
  hero.classList.add('is-live');
  if(!reduce){
    new IntersectionObserver(function(es){es[0].isIntersecting?start():stop();}).observe(hero);
    document.addEventListener('visibilitychange',function(){document.hidden?stop():start();});
    hero.addEventListener('pointermove',function(e){
      var r=hero.getBoundingClientRect();
      m.active=true;m.tx=e.clientX-r.left;m.ty=e.clientY-r.top;
      var nx=(e.clientX-r.left)/r.width-.5,ny=(e.clientY-r.top)/r.height-.5;
      mark.style.setProperty('--ry',(nx*5).toFixed(2)+'deg');
      mark.style.setProperty('--rx',(-ny*4).toFixed(2)+'deg');
    });
    hero.addEventListener('pointerleave',function(){
      m.active=false;mark.style.setProperty('--rx','0deg');mark.style.setProperty('--ry','0deg');
    });
    var ticking=false;
    window.addEventListener('scroll',function(){
      if(ticking)return;ticking=true;
      requestAnimationFrame(function(){
        var p=Math.min(1,window.scrollY/(hero.offsetHeight*.9));
        inner.style.transform='translateY('+(p*90).toFixed(1)+'px) scale('+(1-p*.06).toFixed(4)+')';
        inner.style.opacity=(1-p*1.1).toFixed(3);
        ticking=false;
      });
    },{passive:true});
  }
}
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations"] && !Shopify.designMode) return;
  try {
    
(function(){
function nvRun(){
document.querySelectorAll('[data-spots-map]').forEach(function(map){
  var section=map.closest('.nv-spots');
  var pins={},peeks={},open=null,hideT=0,focusedAt=0;
  map.querySelectorAll('.nv-pin').forEach(function(p){pins[p.dataset.pin]=p;});
  map.querySelectorAll('[data-peek]').forEach(function(c){peeks[c.dataset.peek]=c;});
  function show(id){
    clearTimeout(hideT);
    if(open&&open!==id)hide(open,true);
    var p=pins[id],c=peeks[id];if(!p||!c)return;
    p.classList.add('is-on');p.setAttribute('aria-expanded','true');c.classList.add('is-open');open=id;
  }
  function hide(id,now){
    var run=function(){var p=pins[id],c=peeks[id];if(p){p.classList.remove('is-on');p.setAttribute('aria-expanded','false');}if(c)c.classList.remove('is-open');if(open===id)open=null;};
    if(now)run();else{clearTimeout(hideT);hideT=setTimeout(run,120);}
  }
  Object.keys(pins).forEach(function(id){
    var p=pins[id],c=peeks[id];
    p.addEventListener('mouseenter',function(){show(id);});
    p.addEventListener('mouseleave',function(){hide(id);});
    p.addEventListener('focus',function(){show(id);focusedAt=Date.now();});
    p.addEventListener('blur',function(){hide(id);});
    p.addEventListener('click',function(e){e.preventDefault();if(Date.now()-focusedAt<400)return;open===id?hide(id,true):show(id);});
    if(c){c.addEventListener('mouseenter',function(){clearTimeout(hideT);});c.addEventListener('mouseleave',function(){hide(id);});}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&open)hide(open,true);});
  document.addEventListener('click',function(e){if(open&&!map.contains(e.target))hide(open,true);});
  if(section)section.querySelectorAll('.nv-spot').forEach(function(row){
    var id=row.dataset.pin;
    row.addEventListener('mouseenter',function(){show(id);});
    row.addEventListener('mouseleave',function(){hide(id);});
    row.addEventListener('focusin',function(){show(id);});
    row.addEventListener('focusout',function(){hide(id);});
  });
});
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function(){
function nvRun(){
  document.querySelectorAll('select[data-default]').forEach(function(s){
    var d=s.getAttribute('data-default');
    for(var i=0;i<s.options.length;i++){if(s.options[i].value===d){s.selectedIndex=i;break;}}
  });
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
function nvRun(){
var g=document.querySelector('[data-gallery]');
if(g){
  var main=g.querySelector('[data-gallery-main]');
  g.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      g.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.removeAttribute('aria-current');});
      t.setAttribute('aria-current','true');
      main.classList.add('is-swap');
      setTimeout(function(){main.src=t.dataset.src;main.alt=t.dataset.alt;main.classList.remove('is-swap');},180);
    });
  });
}
var form=document.getElementById('nvPdpForm');
if(form){
  var idInput=form.querySelector('[data-variant-input]'),add=form.querySelector('[data-add]'),now=document.querySelector('[data-price-now]');
  form.querySelectorAll('input[type="radio"][data-variant-id]').forEach(function(r){
    r.addEventListener('change',function(){
      idInput.value=r.dataset.variantId;now.textContent=r.dataset.price;
      var ok=r.dataset.available==='true';add.disabled=!ok;add.textContent=ok?'Kosárba':'Elfogyott';
    });
  });
  var qty=form.querySelector('[name="quantity"]');
  form.querySelectorAll('[data-qty]').forEach(function(b){
    b.addEventListener('click',function(){qty.value=Math.min(9,Math.max(1,(+qty.value||1)+(+b.dataset.qty)));});
  });
}
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
function nvRun(){
/* demo-side validation + confirmation; on Shopify the form posts and form.posted_successfully renders the message */
var form=document.getElementById('nvNews');
if(form){
  form.noValidate=true;
  var input=form.querySelector('[type="email"]'),msg=form.querySelector('.nv-news__msg');
  var ok=msg.getAttribute('data-ok');
  form.addEventListener('submit',function(ev){
    var v=input.value.trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){
      ev.preventDefault();msg.className='nv-news__msg is-err';
      msg.textContent=v.indexOf('@')<0?'Hiányzik a @ az e-mail-címből. Ellenőrizd, és próbáld újra.':'Ez nem teljes e-mail-cím. Ellenőrizd a @ utáni részt.';
      input.setAttribute('aria-invalid','true');input.focus();return;
    }
    input.removeAttribute('aria-invalid');
    if(window.Shopify)return;
    ev.preventDefault();msg.className='nv-news__msg is-ok';msg.textContent=ok;form.reset();
  });
}
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
(function(){
function nvRun(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-stats]').forEach(function(bar){
    var nums=[].slice.call(bar.querySelectorAll('[data-count]')).map(function(el){
      var text=el.textContent,parts=text.split(/(\d+)/);
      return {el:el,parts:parts,targets:parts.map(function(p){return /^\d+$/.test(p)?+p:null;})};
    });
    function paint(t){
      nums.forEach(function(n){
        n.el.textContent=n.parts.map(function(p,i){return n.targets[i]===null?p:Math.round(n.targets[i]*t);}).join('');
      });
    }
    function run(){
      bar.classList.add('is-in');
      if(reduce){paint(1);return;}
      var t0=performance.now(),dur=1600;
      (function step(now){var x=Math.min(1,(now-t0)/dur),e=1-Math.pow(1-x,4);paint(e);if(x<1)requestAnimationFrame(step);})(t0);
    }
    if(!('IntersectionObserver' in window)){run();return;}
    if(!reduce)paint(0);
    var io=new IntersectionObserver(function(es){if(es[0].isIntersecting){io.disconnect();run();}},{threshold:.35});
    io.observe(bar);
  });
}
if(document.readyState!=='loading')nvRun();else document.addEventListener('DOMContentLoaded',nvRun);
})();

  } catch(e) { console.error(e); }
})();
})();
